import Request from './request'

const Attachments = {
  attachmentsImage (params, callback) {
    Request.sendfile('attachments/image', params).then(callback).catch(this.bad_answer)
  },
}
export default Attachments
